const workingShifts = [
  {
    name: "Morning",
    value: "MORNING",
  },
  {
    name: "Afternoon",
    value: "AFTERNOON",
  },
  {
    name: "Night",
    value: "NIGHT",
  },
  {
    name: "None",
    value: null,
  },
];

export default workingShifts;
